export default "__VITE_ASSET__22dfdd6f__"